<template>
  <div>
    <span
      v-for="(button, index) in buttons"
      :key="index"
      class="table-action__container"
    >
      <TableActionButton
        v-if="
          (button.showCondition && button.showCondition(row)) ||
          !button.showCondition
        "
        :label="$t(`tableButtons.${getButtonName(button)}`)"
        :button-icon="
          button.secondaryIcon ? button.secondaryIcon(row) : button.icon
        "
        :disabled="
          button.disableCondition ? button.disableCondition(row) : false
        "
        :click-function="
          () => {
            if (!(button.disableCondition && button.disableCondition(row))) {
              $emit('actionClick', getButtonName(button));
            }
          }
        "
      />
    </span>
  </div>
</template>

<script>
  import TableActionButton from '@/components/TableActionButton.vue';
  import acl from '../services/acl';

  export default {
    name: 'TableActions',
    components: {
      TableActionButton,
    },
    props: {
      configuration: {
        type: Object,
        default: () => {},
      },
      hasPermissions: {
        type: Boolean,
        default: () => true,
      },
      row: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        buttons: [],
      };
    },
    created() {
      if (this.hasPermissions) {
        this.buttons = this.configuration.buttons.filter((button) =>
          acl.userCanUse(button.permissions)
        );
      } else this.buttons = this.configuration.buttons;
    },
    methods: {
      getButtonName(button) {
        return typeof button.name === 'function'
          ? button.name(this.row)
          : button.name;
      },
    },
  };
</script>
